import { useLink } from "@refinedev/core";
import { Box, Typography } from "@mui/material";
import React from "react";
import { MecoLogo } from "../svgs";
import MuiLink from "@mui/material/Link";
import { useBranch } from "../../provider/BranchProvider";

export default function CustomTitle(props: { collapsed: boolean }) {
  const Link = useLink();
  const branch = useBranch();
  return (
    <MuiLink
      component={Link}
      to="/"
      underline="none"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        minWidth: 0,
      }}
    >
      {branch?.style?.logoImage ? (
        <Box
          component="img"
          src={branch?.style?.logoImage?.url}
          alt="Logo"
          sx={{
            height: 32,
            maxWidth: 110,
            objectFit: "contain",
          }}
        />
      ) : (
        <MecoLogo
          sx={{
            height: 32,
            width: 32,
          }}
        />
      )}
      {!props.collapsed && (
        <Typography
          variant="subtitle1"
          color="text.primary"
          sx={{
            fontFamily: "Montserrat",
            fontWeight: 600,
            lineHeight: 1.2,
            // Allow up to two lines for long branch names instead of a hard ellipsis.
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            wordBreak: "break-word",
          }}
        >
          {branch?.name || "meco"}
        </Typography>
      )}
    </MuiLink>
  );
}
